import { createContext } from "react";
import { AttendancesContextType, PspContextType } from "./types";

export const PspContext = createContext<PspContextType>({
  initialized: false,
  lang: "de",
  user: undefined,
  setUser: () => {},
  setLang: () => {},
  leftBarMobileOpen: false,
  setLeftBarMobileOpen: () => {},
  selectedMandate: undefined,
  setSelectedMandate: () => {},
  selectedMandateId: null,
  setSelectedMandateId: () => {},
  setCookieConsentDialogOpen: () => {},
  cookieConsentFunctionalOnly: undefined,
  setCookieConsentFunctionalOnly: () => {},
  msalInstance: undefined,
  mfaSetupState: "closed",
  setMfaSetupState: () => {},
  onMfaMethodCreatedRef: undefined,
  actorId: null,
  setActorId: () => {},
});

const today = new Date();
export const AttendancesContext = createContext<AttendancesContextType>({
  attendanceMonth: undefined,
  setAttendanceMonth: () => {},
  tempAttendanceMonth: undefined,
  setTempAttendanceMonth: () => {},
  availableMonths: undefined,
  setAvailableMonths: () => {},
  attendanceVersions: undefined,
  setAttendanceVersions: () => {},
  selectedMonth: today.getMonth() + 1,
  setSelectedMonth: () => {},
  selectedYear: today.getFullYear(),
  setSelectedYear: () => {},
  isSubmitted: undefined,
  setIsSubmitted: () => {},
  submittedAt: undefined,
  setSubmittedAt: () => {},
  availableGiustificativi: undefined,
  setAvailableGiustificativi: () => {},
});
